import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import { GetUsersForOutboundModalEmployeeTableQuery } from '@api/generated/graphql';

export const getUsersForOutboundModalEmployeeTableQuery = graphql(`
  query getUsersForOutboundModalEmployeeTable {
    users {
      items {
        id
        name
        email
        personalLine {
          phoneNumber
        }
      }
      totalCount
    }
  }
`);

export type UserQueryItem = Exclude<
  Exclude<
    GetUsersForOutboundModalEmployeeTableQuery['users'],
    undefined | null
  >['items'],
  undefined | null
>[0];

export const getUsersForOutboundModalEmployeeTable = async (): Promise<
  UserQueryItem[]
> => {
  const { data, error } = await getClient().query({
    query: getUsersForOutboundModalEmployeeTableQuery,
  });

  if (error) {
    throw new Error(error.message);
  }

  const users = [...(data?.users?.items ?? [])].filter(
    (user) => user.personalLine?.phoneNumber,
  );
  // sort users so that the ones with phone number are at the top then sort by name
  users.sort((a, b) => {
    const aHasPhoneNumber = Boolean(a.personalLine?.phoneNumber);
    const bHasPhoneNumber = Boolean(b.personalLine?.phoneNumber);

    if (aHasPhoneNumber && !bHasPhoneNumber) {
      return -1;
    }
    if (!aHasPhoneNumber && bHasPhoneNumber) {
      return 1;
    }

    return a.name.localeCompare(b.name);
  });

  return users;
};
